<select [(ngModel)]="$node().parameters.condition.variantOperator">
    @for (operator of $booleanOperators(); track operator) {
        <option [value]="operator">{{ operator }}</option>
    }
</select>
<cm-toggle [(toggle)]="$node().parameters.condition.negated" matTooltip="Negated" matTooltipPosition="above"> </cm-toggle>
